const style = {
  textAlignment: {
    alignment: 'center',
  },
  darkGreen: {
    color: '#404048',
  },
  acridGreen: {
    color: '#34565f',
  },
  number: {
    fontSize: 14,
    margin: [0, 0, 0, 340],
  },
  name: {
    fontSize: 27,
    margin: [0, 0, 0, 0],
  },
  birth: {
    fontSize: 14,
    margin: [0, 8, 0, 63],
  },
  cert: {
    fontSize: 20,
    margin: [0, 0, 0, 0],
  },
  city: {
    fontSize: 14,
    margin: [0, 12, 0, 31],
  },
  info: {
    fontSize: 14,
    margin: [30, 0, 30, 35],
  },
  slogan: {
    fontSize: 16,
    color: '#1cb5bf',
    margin: [70, 0, 70, 0],
  },
  logo: {
    alignment: 'right',
    margin: [0, -30, 0, 0],
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/tools/generatepdf/pdfstyle.ts